import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/index.css';
import logger from './utils/logger';
import { handleGlobalKeyDown } from './utils/globalKeyboardShortcuts';
import { ThemeProvider } from './theme/ThemeProvider';

// グローバルエラーハンドラー
window.addEventListener('error', (event) => {
  // 開発環境でのViteやReact DevToolsからのエラーは無視
  if (event.filename?.includes('react-devtools') ||
      event.filename?.includes('chrome-extension://') ||
      (event.message?.includes('logger is not defined') && event.filename?.includes('<anonymous>'))) {
    return;
  }
  logger.error('Uncaught error', event.error, {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno
  });
});

window.addEventListener('unhandledrejection', (event) => {
  logger.error('Unhandled promise rejection', new Error(String(event.reason)));
});

const container = document.getElementById('root');
logger.info(`React root element found: ${container !== null}`);

if (!container) {
  logger.error('Root element not found in DOM!');
  throw new Error('Root element not found');
}


const root = createRoot(container);
root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
logger.info('React app rendered successfully');

// グローバルキーボードイベントハンドラを登録
window.addEventListener('keydown', (event) => {
  handleGlobalKeyDown(event);
});
logger.info('Keyboard shortcuts initialized');
